const log = {
    invalid_type: 'Тип журнала недействительный.',
    invalid_time_window: '`end_time` должно быть позже, чем `start_time`.',
};
export default Object.freeze(log);
